import { SellerRegisterForm } from "../../components/seller/SellerRegisterForm";

import React from "react";
import Grid from '@mui/material/Grid';


function SellerRegister() {

  return (
    <div>
      <div className="tw-px-5 tw-w-96 tw-inline-block tw-justify-center sm:tw-ml-20 tw-text-left">
        
          <Grid container direction="row" alignItems="center" justifyContent="" >

            <Grid container>
              <Grid item xs={12} sm={12}>
                <span className="tw-p-10 tw-text-3xl"><p>Seller Registration</p></span>
              </Grid>
            </Grid>

            <SellerRegisterForm />

          </Grid>
          
      </div>

    </div>
  );

}


export { SellerRegister };
